var _rect, _rect2, _path, _path2, _rect3, _rect4, _rect5, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklistActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D8D8D8",
    fillOpacity: 0.01
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    stroke: "#979797",
    strokeOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2425 2.09141C11.3294 1.74383 11.6417 1.5 12 1.5C12.3583 1.5 12.6706 1.74383 12.7575 2.09141L13.3596 4.5H10.6404L11.2425 2.09141Z",
    fill: "#6C65F7",
    fillOpacity: 0.16,
    stroke: "#6C65F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V10H4V6Z",
    fill: "#6C65F7",
    fillOpacity: 0.16
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 15,
    height: 17,
    rx: 1.5,
    stroke: "#6C65F7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 12,
    height: 1,
    rx: 0.2,
    fill: "#6C65F7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 3,
    width: 8,
    height: 3,
    rx: 1,
    fill: "#6C65F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7757 13.0586C14.8538 12.9805 14.9805 12.9805 15.0586 13.0586L15.4828 13.4828C15.5609 13.5609 15.5609 13.6876 15.4828 13.7657L11.4121 17.8364C11.334 17.9145 11.2074 17.9145 11.1293 17.8364L9.05858 15.7657C8.98047 15.6876 8.98047 15.5609 9.05858 15.4828L9.48284 15.0586C9.56095 14.9805 9.68758 14.9805 9.76568 15.0586L11.1293 16.4222C11.2074 16.5003 11.334 16.5003 11.4121 16.4222L14.7757 13.0586Z",
    fill: "#6C65F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistActive);
export default __webpack_public_path__ + "static/media/checklist-active.08e9528695953602bd33c70f3e459f54.svg";
export { ForwardRef as ReactComponent };